import { Binder } from './bitmovin/interfaces';
import { XHRFactory } from '@kollective-frontend/ksdk-api';
import KollectiveXHR from '../interceptor/KollectiveXHR';

const generateXHRFactory = (binder: Binder): XHRFactory => {
  return (): XMLHttpRequest => {
    if (
      binder.shouldIntercept &&
      binder.getOptions &&
      binder.shouldIntercept()
    ) {
      const options = binder.getOptions();

      return new KollectiveXHR(options) as unknown as XMLHttpRequest;
    } else {
      return new XMLHttpRequest();
    }
  };
};

export default generateXHRFactory;
